import { render, staticRenderFns } from "./SubscriptionOverviewTab.vue?vue&type=template&id=44b506b8&scoped=true"
import script from "./SubscriptionOverviewTab.vue?vue&type=script&lang=js"
export * from "./SubscriptionOverviewTab.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionOverviewTab.vue?vue&type=style&index=0&id=44b506b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b506b8",
  null
  
)

export default component.exports